module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("First published in 2007 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("New Holland Publishers (UK) Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("London • Cape Town • Sydney • Auckland")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Garfield House")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Unit 1, 66 Gibbes Street")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("86–88 Edgware Road")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Chatswood")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("London W2 2EA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("NSW 2067")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "href": "https://www.newhollandpublishers.com",
      "target": "_blank"
    }
  }, [_vm._v("www.newhollandpublishers.com")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Australia")])])])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("80 McKenzie Street")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("218 Lake Road")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Cape Town 8001")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Northcote, Auckland")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("South Africa")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("New Zealand")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © 2007 text and photographs: New Holland Publishers (UK)Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © 2007 New Holland Publishers (UK)Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Joy Skipper has asserted her moral right to be identified as the author of this work.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior written permission of the publishers and copyright holders.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN 978 184537 781 6")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Senior Editor:Clare Sayer")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photographer: Ian Garlick")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Designer: Ian Sandom")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Food Styling: Stella Murphy")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production: Marion Storz")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Editorial Direction: Rosemary Wilkinson")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Reproduction by Pica Digital PTE Ltd, Singapore")]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }, [_c('p', {
    staticClass: "imaget"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0005-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }, [_c('p', {
    staticClass: "imaget"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0006-01.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0